export type SupportedLanguage = 'en' | 'he' | 'es';

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = ['en', 'he', 'es'];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';

// Kept out of ngx-translate on purpose: its table is shared with the HTTP loader,
// which overwrites the 'en' bucket once assets/i18n/en.json resolves.
export const SESSION_TRANSLATIONS: Record<SupportedLanguage, Record<string, string>> = {
  en: {
    'LOGIN.TITLE': 'Login',
    'LOGIN.ACCESS_CODE': 'Access code',
    'LOGIN.ACCESS_CODE_REQUIRED': 'Access code is required.',
    'LOGIN.USERNAME': 'User Name',
    'LOGIN.USERNAME_REQUIRED': 'Username is required.',
    'LOGIN.PASSWORD': 'Password',
    'LOGIN.PASSWORD_REQUIRED': 'Password is required.',
    'LOGIN.SUBMIT': 'Login',
    'LOGIN.CLIENT_VERSION': 'Client version:',
    'LOGIN.API_VERSION': 'API version:',
    'LOGIN.INVALID_CREDENTIALS': 'Invalid user name or password',
    'CHANGE_PASSWORD.TITLE': 'Change password',
    'CHANGE_PASSWORD.OLD_PASSWORD': 'Old password',
    'CHANGE_PASSWORD.NEW_PASSWORD': 'New password',
    'CHANGE_PASSWORD.RETYPE_NEW_PASSWORD': 'Retype new password',
    'CHANGE_PASSWORD.MATCH_ERROR': 'Password must match.',
    'CHANGE_PASSWORD.CANCEL': 'Cancel',
    'CHANGE_PASSWORD.SAVE': 'Save',
    'CHANGE_PASSWORD.POLICY_ERROR': 'Password must be 7 to 14 characters long and include an uppercase letter, a lowercase letter and a number.',
    'CHANGE_PASSWORD.GENERIC_ERROR': 'Could not change the password. Please try again.',
  },
  he: {
    'LOGIN.TITLE': 'התחברות',
    'LOGIN.ACCESS_CODE': 'קוד גישה',
    'LOGIN.ACCESS_CODE_REQUIRED': 'נדרש קוד גישה.',
    'LOGIN.USERNAME': 'שם משתמש',
    'LOGIN.USERNAME_REQUIRED': 'נדרש שם משתמש.',
    'LOGIN.PASSWORD': 'סיסמה',
    'LOGIN.PASSWORD_REQUIRED': 'נדרשת סיסמה.',
    'LOGIN.SUBMIT': 'התחברות',
    'LOGIN.CLIENT_VERSION': 'גרסת לקוח:',
    'LOGIN.API_VERSION': 'גרסת API:',
    'LOGIN.INVALID_CREDENTIALS': 'שם משתמש או סיסמה שגויים',
    'CHANGE_PASSWORD.TITLE': 'שינוי סיסמה',
    'CHANGE_PASSWORD.OLD_PASSWORD': 'סיסמה נוכחית',
    'CHANGE_PASSWORD.NEW_PASSWORD': 'סיסמה חדשה',
    'CHANGE_PASSWORD.RETYPE_NEW_PASSWORD': 'הקלידו שוב את הסיסמה החדשה',
    'CHANGE_PASSWORD.MATCH_ERROR': 'הסיסמאות חייבות להיות זהות.',
    'CHANGE_PASSWORD.CANCEL': 'ביטול',
    'CHANGE_PASSWORD.SAVE': 'שמירה',
    'CHANGE_PASSWORD.POLICY_ERROR': 'הסיסמה חייבת להכיל בין 7 ל-14 תווים, ולכלול אות גדולה, אות קטנה וספרה.',
    'CHANGE_PASSWORD.GENERIC_ERROR': 'לא ניתן לשנות את הסיסמה. נסו שוב.',
  },
  es: {
    'LOGIN.TITLE': 'Iniciar sesión',
    'LOGIN.ACCESS_CODE': 'Código de acceso',
    'LOGIN.ACCESS_CODE_REQUIRED': 'El código de acceso es obligatorio.',
    'LOGIN.USERNAME': 'Usuario',
    'LOGIN.USERNAME_REQUIRED': 'El usuario es obligatorio.',
    'LOGIN.PASSWORD': 'Contraseña',
    'LOGIN.PASSWORD_REQUIRED': 'La contraseña es obligatoria.',
    'LOGIN.SUBMIT': 'Iniciar sesión',
    'LOGIN.CLIENT_VERSION': 'Versión de cliente:',
    'LOGIN.API_VERSION': 'Versión de API:',
    'LOGIN.INVALID_CREDENTIALS': 'Usuario o contraseña incorrectos',
    'CHANGE_PASSWORD.TITLE': 'Cambiar contraseña',
    'CHANGE_PASSWORD.OLD_PASSWORD': 'Contraseña actual',
    'CHANGE_PASSWORD.NEW_PASSWORD': 'Nueva contraseña',
    'CHANGE_PASSWORD.RETYPE_NEW_PASSWORD': 'Repita la nueva contraseña',
    'CHANGE_PASSWORD.MATCH_ERROR': 'Las contraseñas deben coincidir.',
    'CHANGE_PASSWORD.CANCEL': 'Cancelar',
    'CHANGE_PASSWORD.SAVE': 'Guardar',
    'CHANGE_PASSWORD.POLICY_ERROR': 'La contraseña debe tener entre 7 y 14 caracteres e incluir una letra mayúscula, una minúscula y un número.',
    'CHANGE_PASSWORD.GENERIC_ERROR': 'No se pudo cambiar la contraseña. Inténtelo de nuevo.',
  },
};
